export default function Loading() {
  return (
    <div className="text-center">
      <i className="fa fa-spinner fa-spin fa-2x" />
    </div>
  );
}
